import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import NProgress from 'vue-nprogress'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
import VueUpload from '@websanova/vue-upload'
import { TOGGLE_SIDEBAR } from 'vuex-store/mutation-types'
import numeral from 'numeral'
import Meta from 'vue-meta'

Vue.router = router
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = 'https://www.filesbeast.net/'
Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
  tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
    },

    response: function (res) {
      let headers = this.options.http._getHeaders.call(this, res)
      let token = headers.Authorization || headers.authorization
      if (token !== null && token !== undefined) {
        token = token.split(/Bearer:?\s?/i)

        return token[token.length > 1 ? 1 : 0].trim()
      }

      return false
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {url: '/api/v1/login', fetchUser: true},
  refreshData: {enabled: false},
  fetchData: {url: '/api/v1/user'},
  rolesVar: 'role'
})

Vue.use(NProgress)
// Enable devtools
Vue.config.devtools = true
Vue.use(VueUpload, {
  http: function (data) {
    this.Vue.axios.post(data.url, data.body, {
      progress: data.progress
    })
      .then(function (response) {
        if (response.data.success) {
          data.success(response)
        } else {
          data.error(response)
        }
      })
  },
  maxSizePerFile: 1024 * 1024 * 5000,
  extensions: ['jpeg', 'jpg', 'png', 'gif', 'zip', 'tar.xz', 'tar.gz', 'rar', 'apk', 'exe', 'msi', 'tar.md5', 'tar', 'tar.bz2', 'md5', 'gz', 'xz', 'bz2'],
  multiple: true,
  async: true,
  maxFilesInProgress: 5
})
Vue.use(require('vue-msg-bag'))
Vue.filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number')
  }

  let exponent
  let unit
  let neg = num < 0
  let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  if (neg) {
    num = -num
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B'
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1)
  num = (num / Math.pow(1024, exponent)).toFixed(2) * 1
  unit = units[exponent]

  return (neg ? '-' : '') + num + ' ' + unit
})

Vue.filter('uppercase', function (value) {
  if (!value) {
    return ''
  }

  return value.toString().toUpperCase()
})

Vue.filter('formatNumber', function (value) {
  return numeral(value).format('0,0') // displaying other groupings/separators is possible, look at the docs
})

Vue.filter('capitalize', function (value) {
  if (!value) {
    return ''
  }

  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
sync(store, router)

const nprogress = new NProgress({parent: '.nprogress-container'})

const {state} = store

router.beforeEach((route, redirect, next) => {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    store.commit(TOGGLE_SIDEBAR, false)
  }
  next()
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const app = new Vue({
  router,
  store,
  nprogress,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js